import { addPanelVents } from '../../panels/helpers';
import { Island } from '../island.class';
import { Panel } from '../../panels/panel.class';
import { ReferenceMap } from '../../shared.types';

export type AddIslandVentsParams = {
	island: Island;
	refMap: ReferenceMap;
};

export const addIslandVents = (params: AddIslandVentsParams): void => {
	// console.log('islands:helpers:-> addIslandVents', params);
	const { island, refMap } = params;
	let numAdded = 0;

	island?.panels?.children.forEach((panel) => {
		numAdded += addPanelVents({ panel: panel as Panel, refMap });
	});

	if (numAdded > 0) console.info('%cVents were added to the island\'s panels.', 'color:green;font-weight:bold;border:1px solid black;padding:5px;');
	// console.log('islands:helpers:<- addIslandVents', { count: numAdded });
};
